require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-padmajaruparelofindianangelnetwork.json") })
        }
      }, "path---insights-padmajaruparelofindianangelnetwork");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-padmajaruparelofindianangelnetwork!./.cache/json/insights-padmajaruparelofindianangelnetwork.json
// module id = 1116
// module chunks = 231608221292675